import { getEnvConfig } from 'envConfig';
import jsCookie from 'js-cookie';
import { useEffect } from 'react';
import { useFinalColorScheme } from 'technical/useFinalColorScheme';

const cookieName = 'ui-theme';
const colorSchemeStorage = {
  get: (): string | null => {
    return jsCookie.get(cookieName) ?? null;
  },
  set: (value: string): void => {
    jsCookie.set(cookieName, value, {
      expires: 365,
      domain: getEnvConfig().cookieDomain,
      sameSite: 'lax',
    });
  },
};

// clear joy color scheme from local storage when the file is executed
localStorage.removeItem('joy-mode');
localStorage.setItem('joy-mode', colorSchemeStorage.get() ?? 'light');

export const CookieColorSchemeUpdater = () => {
  // keep cookie in sync with joy color scheme
  const colorScheme = useFinalColorScheme();
  useEffect(() => {
    colorSchemeStorage.set(colorScheme);
  }, [colorScheme]);

  return null;
};
